// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"129":"88012fbd1ffc811a","232":"78afef02d7a3af67"}[chunkId] + ".js";
};